import React from 'react';
import { cn } from '../shared/utils';

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-zinc-300', className)}
      {...props}
    />
  );
}

export { Skeleton };
